@if (initialized) {

  <div class="mx-auto p-2" style="max-width: 45rem;">

    <div [formGroup]="formGroup">
      <div class="surface-card p-2 border-round w-full">
        <div class="text-center mb-6">
          <div class="text-color text-3xl font-semibold mb-2">Persönliche Daten</div>
          <span class="text-color-secondary text-sm">Wir benötigen noch ein paar Informationen von dir. Keine Sorge, deine Daten sind bei uns sicher!</span>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="grid formgrid p-fluid">
              <div class="field md:col-6 col-12">
                <label for="firstName" class="font-medium text-900">Vorname<span class="text-red-500">*</span></label>
                <span class="p-input-icon-left">
                  <i class="pi pi-user"></i>
                <input id="firstName" formControlName="firstName" type="text" pInputText>
                </span>
              </div>

              <div class="field md:col-6 col-12">
                <label for="lastName" class="font-medium text-900">Nachname<span class="text-red-500">*</span></label>
                <span class="p-input-icon-left">
                  <i class="pi pi-user"></i>
                <input id="lastName" formControlName="lastName" type="text" pInputText>
                </span>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="flex flex-column field">
              <label for="firstName" class="font-medium text-900">Geschlecht<span class="text-red-500">*</span></label>
              <p-selectButton
                formControlName="gender"
                styleClass="custom-padding"
                [options]="genderOptions"
                [allowEmpty]="false"
                optionLabel="label"
                optionValue="key"
              ></p-selectButton>
            </div>
          </div>

          <div class="col-12">
            <div class="flex flex-column field">
              <label for="firstName" class="font-medium text-900">Ansprache in Beratungsgesprächen<span
                class="text-red-500">*</span></label>
              <p class="text-sm text-color-secondary mt-0">
                Bitte habe jedoch Verständnis dafür, dass wir innerhalb unserer Apps Texte in der 'Du'-Form verwenden
              </p>
              <p-selectButton
                formControlName="addressCasually"
                [options]="addressOptions"
                [allowEmpty]="false"
                optionLabel="label"
                optionValue="key"
              ></p-selectButton>
            </div>
          </div>

          <div class="col-12">
            <div class="grid formgrid p-fluid">
              <div class="field md:col-6 col-12">
                <label for="nickname" class="font-medium text-900">Spitzname</label>
                <input id="nickname" formControlName="nickName" type="text" pInputText>
              </div>

              <div class="field md:col-6 col-12">
                <label for="birthDate" class="font-medium text-900">Geburtsdatum<span
                  class="text-red-500">*</span></label>
                <p-calendar id="birthDate"
                            formControlName="dateOfBirth"
                            [iconDisplay]="'input'"
                            dateFormat="dd.mm.yy"
                            (input)="formatDateInputOnInput($event)"
                            (onSelect)="calculateAge($event)"
                            appendTo="body"
                            [showIcon]="true"
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                            [defaultDate]="defaultDate">
                </p-calendar>
                <div *ngIf="ageDetails">
                  <p>{{ ageDetails }}</p>
                </div>

              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="grid formgrid p-fluid">
              <div class="field md:col-6 col-12">
                <label for="maritalStatus" class="font-medium text-900">Familienstand</label>
                <p-dropdown id="maritalStatus" formControlName="maritalStatus"
                            [options]="maritalStatus"
                            optionLabel="label"
                            optionValue="key"
                            [filter]="true"
                            appendTo="body"
                            filterBy="label">
                </p-dropdown>
              </div>

              <div class="field md:col-6 col-12">
                <label for="childrenCount" class="font-medium text-900">Anzahl Kinder</label>
                <!--                <p-inputNumber id="childrenCount" formControlName="childrenCount" mode="decimal" inputId="withoutgrouping" [useGrouping]="false"> </p-inputNumber>-->
                <p-dropdown id="childrenCount"
                            formControlName="childrenCount"
                            [options]="noOfChildrenOptions"
                            optionLabel="label"
                            optionValue="key"
                            appendTo="body"
                            filterBy="label">
                </p-dropdown>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="grid formgrid p-fluid">

              <!-- phoneNumber (Read-Only) -->
              <div class="field md:col-6 col-12">
                <label for="phoneNumber" class="font-medium text-900">Mobil</label>
                <span class="p-input-icon-left">
        <i class="pi pi-phone"></i>
        <input
          id="phoneNumber"
          formControlName="phoneNumber"
          type="text"
          pInputText
          readonly
          class="bg-gray-100 cursor-not-allowed"
        />
      </span>
              </div>

              <!-- homePhoneNumber (Editable) -->
              <div class="field md:col-6 col-12">
                <label for="homePhoneNumber" class="font-medium text-900">Festnetz</label>
                <span class="p-input-icon-left">
        <i class="pi pi-home"></i>
        <input
          id="homePhoneNumber"
          formControlName="homePhoneNumber"
          type="text"
          pInputText
        />
      </span>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="flex justify-content-between col-12 py-4">
      <div>
        <!--      <p-button (click)="navigatePreviousStep(1)" label="Zurück" severity="secondary" [text]="true" iconPos="left" icon="pi pi-arrow-left"></p-button>-->
      </div>

      <div>
        <!--      <p-button [disabled]="!isFormValid()" (click)="updateRegistration()" label="weiter" icon="pi pi-arrow-right" iconPos="right"></p-button>-->
        <app-button [disabled]="!isFormValid()"
                    [busy]="busy"
                    (onClick)="updateRegistration()">
        </app-button>
      </div>
    </div>
  </div>
}
